import { render, staticRenderFns } from "./home_ourBeacons.vue?vue&type=template&id=249a6190"
import script from "./home_ourBeacons.vue?vue&type=script&lang=js"
export * from "./home_ourBeacons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports